/**
 * お問い合わせステータスコード変換ユーティリティ
 *
 * API が返す数値ステータスコードを画面表示用のステータス名に変換する。
 * API enum 定義: home_karte_api/src/core/config/inquiryStatus.ts
 * カルテ Flutter 側の表示マッピング:
 *   homekarte/lib/features/inquiry/domain/entities/inquiry_entity.dart
 * と整合させる。
 *
 * 注: 11 (REVISIT) は仕様変更によりカルテでも「再訪問」として表示する。
 *     70 (COMPLETE_INSPECTION) はドクター側仕様
 *     (home_doctor_front/src/app/consts/values.ts の INQUIRIES_STATUS_MAP['70'])
 *     を踏襲し「調査のみ完了」として表示する。
 */

import type { Inquiry } from '../types';

/**
 * API のステータスコード → 画面表示用ステータス名 マッピング
 *
 * 未知のコードは undefined になるため、呼び出し側はフォールバックを適切に処理すること。
 */
export const statusCodeToName: Record<number, Inquiry['status']> = {
  1: '受付中', // IN_RECEPTION
  2: '受付済', // COMPLETE_RECEPTION
  10: '訪問確定済', // CONFIRMED_VISIT
  11: '再訪問', // REVISIT（仕様変更によりカルテでも表示）
  20: '調査中', // IN_INSPECTION
  30: '調査見積もり済', // COMPLETE_ESTIMATE
  40: '見積もりサイン済', // COMPLETE_ESTIMATE_SIGN
  50: '作業報告書確認', // CONFIRM_REPORT
  60: '支払い待ち', // WAIT_PAYMENT
  70: '調査のみ完了', // COMPLETE_INSPECTION（ドクター仕様踏襲）
  71: '作業完了', // COMPLETE_WORK
  99: 'キャンセル', // CANCEL
};

/**
 * カルテ画面に表示すべきステータスコードかを判定する。
 *
 * 仕様変更により 11 (REVISIT) も表示対象になったため、現状は全コードを表示する。
 * 将来カルテ非表示にすべきコードが出た場合はここで除外する。
 *
 * @param code API から返ってきたステータスコード
 * @returns 一覧などに含めて良ければ true
 */
export const isVisibleStatusCode = (_code: number): boolean => {
  return true;
};
